// 客服弹窗Tab类型
export const PANEL_TYPE = {
  Customer: 'customer',
  Feedback: 'feedback'
} as const
export type PanelType = (typeof PANEL_TYPE)[keyof typeof PANEL_TYPE]

// 客服类型：1 财务客服，2 普通客服，3 浮窗客服，4 维护客服
export enum CustomerType {
  Finance = 1,
  Normal = 2,
  Float = 3,
  Maintenance = 4
}

/** 客服记录 */
export interface CustomerServiceDTO {
  /** 主键 */
  id?: number
  /** 客服类型 */
  customerType?: number
  /** 标题 */
  title?: string
  /** 内容 */
  content?: string
  /** 客服url */
  chatUrl?: string
  /** 图片image */
  imagePc?: string
  image?: string
  /** 链接类型 1-iframe内嵌 2-新窗口打开 */
  chatUrlType?: number
}

/** 反馈记录 */
export interface FeedbackRecordDTO {
  /** 主键 */
  id: number
  /** 用户名 */
  username?: string
  /** 问题类型 */
  questionType?: number
  /** 反馈内容 */
  content?: string
  /** 反馈附件 */
  fileUrl?: string[]
  /** 回复内容 */
  replyContent?: string
  /** 用户头像 */
  userAvatar?: string
  /** 问题回复时间 */
  replyTime?: string
  /** 问题反馈时间 */
  feedbackTime?: string
  /** 是否已读 */
  isRead?: boolean
  /** 显示删除按钮 */
  showDeleteButton?: boolean
}

/** 反馈类型 */
export interface FeedbackTypeDTO {
  /** key */
  objKey?: number
  /** value */
  objValue?: string
}

/** 格式化后的反馈类型包含显示文本 */
export interface FormattedFeedbackTypeDTO extends FeedbackTypeDTO {
  /** 格式化后的显示文本 用于下拉框和列表UI */
  feedbackTypeText: string
}

/** 上传文件状态 */
export interface UploadFileItem {
  /** 文件状态 */
  status: 'uploading' | 'done' | 'failed'
  /** 状态消息 */
  message: string
  /** 原始文件 */
  file: File
  /** 服务器返回的URL */
  resUrl: string
  /** 预览URL */
  previewUrl: string
}

/** 上传文件（扩展 File 接口） */
export interface UploadFile extends File {
  /** 文件状态 */
  status: 'uploading' | 'done' | 'failed'
  /** 状态消息 */
  message: string
  /** 原始文件 */
  file: File
  /** 服务器返回的URL */
  resUrl: string
  /** 预览URL（ObjectURL） */
  previewUrl: string
}
